import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateSelectedFeeSchedule } from '../../../../../services/ContractService/contractSlice';

const FeeTypeEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const selectedFeeSchedule = useAppSelector((state) => state.contract.currentFeeSchedule);

  const handleChange = (event: SelectChangeEvent) => {
    if (selectedFeeSchedule) {
      dispatch(updateSelectedFeeSchedule({
        ...selectedFeeSchedule,
        feeType: event.target.value
      }));
    }
  };

  return (
    <FormControl fullWidth size="small" variant="outlined">
      <InputLabel id="fee-type-label">Fee Type</InputLabel>
      <Select
        labelId="fee-type-label"
        id="fee-type-select"
        value={selectedFeeSchedule?.feeType || ''}
        onChange={handleChange}
        label="Fee Type"
      >
        <MenuItem value="">
          <em>Select fee type</em>
        </MenuItem>
        <MenuItem value="DRG">DRG</MenuItem>
        <MenuItem value="CPT">CPT</MenuItem>
      </Select>
    </FormControl>
  );
};

export default FeeTypeEditor;
